import { rqClient } from "@/shared/api/instance";
import type { ApiSchemas } from "@/shared/api/schema";
import { useSession } from "@/shared/model/session";

export type Store = ApiSchemas["Store"];

export function useStore() {
  const { isAuthenticated } = useSession();

  return rqClient.useQuery(
    "get",
    "/api/v1/stores/me",
    {},
    {
      enabled: isAuthenticated,
    },
  );
}
